import {
  Settings,
  HelpCircle,
  Users,
  Scale,
  Database,
  CircleCheckBig,
  File,
  GitCompareIcon,
  ShieldCheck,
  SearchCheck,
  BookOpen,
  Lightbulb,
} from "lucide-react"
import { FOUNDATION } from "../../constants"
import { SidebarItem } from "./types"
import LRHIcon from "./icons/LRHIcon"

// action types

export const OPEN_SIDEBAR = `${FOUNDATION}_OPEN_SIDEBAR`

export const CLOSE_SIDEBAR = `${FOUNDATION}_CLOSE_SIDEBAR`

export const REPLACE_SIDEBAR = `${FOUNDATION}_REPLACE_SIDEBAR`

export const REMOVE_SIDEBAR = `${FOUNDATION}_REMOVE_SIDEBAR`

// constants

export const REGULATIONS_DATABASE_CONST = "Regulations_Database"

export const KAIZEN_WIKI = "Kaizen_Wiki"

export const VALIDATOR_CONST = "Validator"

export const TOOLS_CONST = "Tools"

export const ORGANISATION_ADMINISTRATION = "Organisation Administration"

export const RESULTS_CONST = "Results"

export const MANAGEMENT_INFORMATION_CONST = "Management Information"

export const ORGANISATION_ADMINISTRATION_CONST = "Organisation Administration"

export const CLIENT_ADMINISTRATION_CONST = "Client Administration"

export const CFI_CODE_GEN_CONST = "CFI Code Generator"

export const INSTRUMENT_LOOKUP_CONST = "Instrument Lookup"

export const MIFID_II_CONST = "MiFID II"

export const HELPDESK_CONST = "Helpdesk"

export const MARGIN_LEFT_CLASS_NAME_SIDEBAR_OPEN =
  "verified-margin-left-sidebar-open"

export const MARGIN_LEFT_CLASS_NAME_SIDEBAR_CLOSED =
  "verified-margin-left-sidebar-closed"

export const REMOVED_SIDEBAR_CLASS_NAME = "no-sidebar"

export const SET_LOTTIE_FUNCTION = `${FOUNDATION}_SET_LOTTIE_FUNCTION`

export const sideBarItems: SidebarItem[] = [
  {
    icon: CircleCheckBig,
    label: "Client Results Service",
    href: "/crs",
  },
  { icon: File, label: "File Transfer Service", href: "/fts" },
  { icon: GitCompareIcon, label: "CloudSinc", href: "/cloudsinc" },
  {
    icon: Settings,
    label: "Control Framework",
    href: "/cf",
  },
  {
    icon: ShieldCheck,
    label: "Identity and Access Management",
    href: "/iam",
  },
  { icon: LRHIcon, label: "London Reporting House", href: "/lrh" },
  {
    icon: SearchCheck,
    label: "Shareholding Disclosure Service",
    href: "/sds",
  },
  {
    icon: Database,
    label: "Short Selling Indicator Lookup",
    href: "/ssil",
  },
  { icon: BookOpen, label: "Single Rulebook", href: "/srb" },
  { icon: HelpCircle, label: "Help", href: "/helpdesk" },
  { icon: Users, label: "Community", href: "/community" },
  { icon: Lightbulb, label: "Wiki", href: "/wiki" },
  { icon: Scale, label: "Legal", href: "/legal" },
]
